<aipb-inside-loading [loading]="true"></aipb-inside-loading>
